import contractTypeComponent from "./contract_type.component";
import contractTypeAll from './all';
import contractTypeCreate from './create';
import contractTypeEdit from './edit';

let contractTypeModule = angular.module('contractType', [
    contractTypeAll,
    contractTypeCreate,
    contractTypeEdit
])

    .component('contractType', contractTypeComponent)

    .config(($stateProvider, $urlRouterProvider) => {
        'ngInject';

        $stateProvider.state('contract_type.all', {
            url: '/all/:page',
            component: 'contractTypeAll'
        })

        $stateProvider.state('contract_type.create', {
            url: '/create',
            component: 'contractTypeCreate'
        })

        $stateProvider.state('contract_type.edit', {
            url: '/edit/:id',
            component: 'contractTypeEdit'
        })
    })
    .name;

export default contractTypeModule;



// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract_type/index.js